// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zeDunwl74ovwCwZjVBKQkQ\\=\\=>span{width:100%;height:100%}.zeDunwl74ovwCwZjVBKQkQ\\=\\=>span>svg{width:100%;height:100%}", "",{"version":3,"sources":["webpack://./components/Icon/styles.module.scss"],"names":[],"mappings":"AACE,iCACE,UAAA,CACA,WAAA,CAEA,qCACE,UAAA,CACA,WAAA","sourcesContent":[".container {\n  > span {\n    width: 100%;\n    height: 100%;\n\n    > svg {\n      width: 100%;\n      height: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "zeDunwl74ovwCwZjVBKQkQ=="
};
export default ___CSS_LOADER_EXPORT___;
